
import { useTranslation } from 'react-i18next';

import { RegistrationStatus } from '__generated__/graphql';

import { TicketLabel } from '../../../../common/Common/SellableLabel';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

export interface RegistrationInfoProps {
  registration: {
    assigned: boolean;
    full_name?: string | null;
    invited_email?: string | null;
    participant: {
      email: string;
    };
    ticket: {
      title: string;
    };
    purchase: {
      active: boolean;
    };
    ticket_number?: string;
    sequence: number;
    status: RegistrationStatus;
    created_at?: string;
  };
}

const RegistrationInfo = ({ registration }: RegistrationInfoProps) => {
  const { t } = useTranslation();
  const { formatDate, parseDate } = useLocale();

  const isCancelled = registration.status === RegistrationStatus.cancelled;

  return (
    <UI.Card sc={{ spacing: 'xs', background: 'gray.50', outline: 'gray.100', borderRadius: 'md' }}>
      <UI.FormGrid sc={{ columns: '1fr fit-content(150px)', gutter: 0.5, alignVertical: 'center' }}>
        <UI.Div>
          <UI.Div sc={{ strong: true }}>
            <UI.Span sc={{ muted: !registration.purchase.active, deleted: isCancelled, mr: 1 }}>
              {registration.assigned
                ? registration.full_name
                : (registration.invited_email || registration.participant.email)}
            </UI.Span>
          </UI.Div>
          <UI.FlexContainer sc={{ wrap: 'wrap' }}>
            <TicketLabel
              ticket={registration.ticket.title}
              status={registration.status}
              sc={{ mt: 0.5, mr: 1 }}
            />
            {registration.status === RegistrationStatus.waitlist && (
              <UI.Label sc={{ small: true, mt: 0.5, mr: 1 }}>
                <UI.Icon>
                  <UI.Icons.Hourglass />
                </UI.Icon>
                {' '}
                {t('waitlist')}
              </UI.Label>
            )}
            {registration.ticket_number && (
              <UI.Label sc={{ small: true, mt: 0.5 }}>
                <UI.Icon>
                  <UI.Icons.StartFinish />
                </UI.Icon>
                {' '}
                {registration.ticket_number}
              </UI.Label>
            )}
          </UI.FlexContainer>
        </UI.Div>
        <UI.Div sc={{ small: true, textAlign: 'right', mt: 0.5 }}>
          <UI.Div sc={{ fontWeight: 500 }}>
            ATL
            {registration.sequence}
          </UI.Div>
          <UI.Div sc={{ mt: 0.5, muted: true }}>
            {formatDate(
              parseDate(registration.created_at, { timezone: 'UTC' }),
              { format: 'display_compact_date' },
            )}
          </UI.Div>
        </UI.Div>
      </UI.FormGrid>
    </UI.Card>
  );
};

export default RegistrationInfo;
